// Acciones para notificaciones y destinatarios (usuarios)
export const fetchEventos = () => async (dispatch, getState) => {
  dispatch({ type: 'FETCH_EVENTOS_REQUEST' });
  try {
    const token = getState().user.userInfo?.token;
    const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}microcredenciales/notificacion/eventos`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    const data = await res.json();
    dispatch({ type: 'FETCH_EVENTOS_SUCCESS', payload: data });
  } catch (error) {
    dispatch({ type: 'FETCH_EVENTOS_FAIL', payload: error.message });
  }
};

export const fetchDestinatarios = () => async (dispatch, getState) => {
  dispatch({ type: 'FETCH_DESTINATARIOS_REQUEST' });
  try {
    const token = getState().user.userInfo?.token;
    const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}microcredenciales/notificacion/destinatarios`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    const data = await res.json();
    dispatch({ type: 'FETCH_DESTINATARIOS_SUCCESS', payload: data });
  } catch (error) {
    dispatch({ type: 'FETCH_DESTINATARIOS_FAIL', payload: error.message });
  }
};

export const createEvento = (evento) => async (dispatch, getState) => {
  dispatch({ type: 'CREATE_EVENTO_REQUEST' });
  try {
    const token = getState().user.userInfo?.token;
    const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}microcredenciales/notificacion/evento/save`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(evento)
    });
    if (!res.ok) throw new Error('Error al crear evento');
    dispatch({ type: 'CREATE_EVENTO_SUCCESS' });
    dispatch(fetchEventos());
  } catch (error) {
    dispatch({ type: 'CREATE_EVENTO_FAIL', payload: error.message });
  }
};

export const createDestinatario = (destinatario) => async (dispatch, getState) => {
  dispatch({ type: 'CREATE_DESTINATARIO_REQUEST' });
  try {
    const token = getState().user.userInfo?.token;
    const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}microcredenciales/notificacion/destinatario/save`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(destinatario)
    });
    if (!res.ok) throw new Error('Error al crear destinatario');
    dispatch({ type: 'CREATE_DESTINATARIO_SUCCESS' });
    dispatch(fetchDestinatarios());
  } catch (error) {
    dispatch({ type: 'CREATE_DESTINATARIO_FAIL', payload: error.message });
  }
};

export const vincularDestinatario = (idEvento, idDestinatario) => async (dispatch, getState) => {
  dispatch({ type: 'VINCULAR_DESTINATARIO_REQUEST' });
  try {
    const token = getState().user.userInfo?.token;
    const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}microcredenciales/notificacion/evento/vincular/${idEvento}/${idDestinatario}`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    if (!res.ok) throw new Error('Error al vincular destinatario');
    dispatch({ type: 'VINCULAR_DESTINATARIO_SUCCESS' });
    dispatch(fetchEventos());
  } catch (error) {
    dispatch({ type: 'VINCULAR_DESTINATARIO_FAIL', payload: error.message });
  }
};

export const desvincularDestinatario = (idEvento, idDestinatario) => async (dispatch, getState) => {
  dispatch({ type: 'DESVINCULAR_DESTINATARIO_REQUEST' });
  try {
    const token = getState().user.userInfo?.token;
    const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}microcredenciales/notificacion/evento/desvincular/${idEvento}/${idDestinatario}`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    if (!res.ok) throw new Error('Error al desvincular destinatario');
    dispatch({ type: 'DESVINCULAR_DESTINATARIO_SUCCESS' });
    dispatch(fetchEventos());
  } catch (error) {
    dispatch({ type: 'DESVINCULAR_DESTINATARIO_FAIL', payload: error.message });
  }
};

export const toggleDestinatarioActivo = (idDestinatario) => async (dispatch, getState) => {
  dispatch({ type: 'TOGGLE_DESTINATARIO_ACTIVO_REQUEST' });
  try {
    const token = getState().user.userInfo?.token;
    // TODO: Reemplazar esta URL con el endpoint correcto
    const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}microcredenciales/notificacion/destinatario/actualizar/${idDestinatario}`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    if (!res.ok) throw new Error('Error al cambiar estado del destinatario');
    dispatch({ type: 'TOGGLE_DESTINATARIO_ACTIVO_SUCCESS' });
    dispatch(fetchDestinatarios());
  } catch (error) {
    dispatch({ type: 'TOGGLE_DESTINATARIO_ACTIVO_FAIL', payload: error.message });
  }
};

export const setDestinatarioPrincipal = (idEvento, idDestinatario) => async (dispatch, getState) => {
  dispatch({ type: 'SET_DESTINATARIO_PRINCIPAL_REQUEST' });
  try {
    const token = getState().user.userInfo?.token;
    const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}microcredenciales/notificacion/evento/${idEvento}/destinatario/${idDestinatario}/principal`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    if (!res.ok) throw new Error('Error al establecer destinatario principal');
    dispatch({ type: 'SET_DESTINATARIO_PRINCIPAL_SUCCESS' });
    dispatch(fetchEventos());
  } catch (error) {
    dispatch({ type: 'SET_DESTINATARIO_PRINCIPAL_FAIL', payload: error.message });
  }
};
